var _a;
import { __decorate, __metadata, __param } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { SpaceActionContribution } from './space-action-contribution';
import { injectable, inject, named } from '@patsnap/tahiti-core/shared/inversify';
import { ContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { Disposable } from '@patsnap/tahiti-core/common/disposable';
function isEnabled(context) {
    return true;
}
function isVisible(context) {
    return true;
}
let SpaceActionRegistryImpl = class SpaceActionRegistryImpl extends AbstractModel {
    constructor(_contributionProvider) {
        super();
        this._contributionProvider = _contributionProvider;
        this._modelData = { actions: [] };
        this._commandIds = new Set();
    }
    clone(modelData) {
        const data = { actions: modelData.actions.map(_ => {
                return { ..._ };
            }) };
        return data;
    }
    dispose() {
        this._commandIds.clear();
        this.update(() => ({ actions: [] }));
    }
    onStart() {
        this._contributionProvider.getContributions().forEach(contribution => {
            contribution.registerSpaceActions(this);
        });
    }
    getSpaceActions() {
        const actions = this.modelData.actions;
        return actions.sort((a, b) => a.order - b.order);
    }
    registerSpaceAction(action) {
        if (this._commandIds.has(action.commandId)) {
            console.warn(`Space action with command ID ${action.commandId} already exists.`);
            return Disposable.NULL;
        }
        const actions = this.modelData.actions;
        const _action = this._normalizeAction(action);
        actions.push(_action);
        this.update(() => ({ actions }));
        this._commandIds.add(action.commandId);
        return {
            dispose: () => {
                this._disposeAction(action);
            },
        };
    }
    _normalizeAction(action) {
        return {
            ...action,
            isEnabled: action.isEnabled || isEnabled,
            isVisible: action.isVisible || isVisible,
            order: action.order || 0,
        };
    }
    _disposeAction(action) {
        const actions = this.modelData.actions;
        const index = actions.findIndex(a => a.commandId === action.commandId);
        if (index !== -1) {
            actions.splice(index, 1);
            this.update(() => ({ actions }));
            this._commandIds.delete(action.commandId);
        }
    }
};
SpaceActionRegistryImpl = __decorate([
    injectable(),
    __param(0, inject(ContributionProvider)),
    __param(0, named(SpaceActionContribution)),
    __metadata("design:paramtypes", [typeof (_a = typeof ContributionProvider !== "undefined" && ContributionProvider) === "function" ? _a : Object])
], SpaceActionRegistryImpl);
export { SpaceActionRegistryImpl };
